import { ITranslationEntry } from '../lang';

export const RU: ITranslationEntry = {
  translations: {
    notifications: 'Уведомления',
    markAllAsRead: 'Пометить все как прочитанные',
    poweredBy: 'При поддержке',
    settings: 'Настройки',
  },
  lang: 'ru',
};
